import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Avatar, Button, Header, Modal } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { useEmployeeServiceData } from "@hooks/useEmployeeServiceData";

import { getEmployeeServiceDataConvert } from "@helpers/employeeServiceDataConvert";

import { ApplyLeaveFormDataType } from "@validations/HRM/leave/applyLeaveFormValidation";

import { EMPLOYEE_SERVICE_DATA } from "@constants/employee-service-data";
import {
  InputDateControllerVertical,
  SelectControllerVertical,
} from "@components";

interface FileInquiryModalType {
  isModalOpen: boolean;
  designation: any[];
  gradeId: any;
  handleSendForApproval: (data?: any) => void;
  onClose: () => void;
  isLoading: boolean;
}

export const FileInquiryModal = ({
  isModalOpen,
  designation,
  gradeId,
  handleSendForApproval,
  onClose,
  isLoading,
}: FileInquiryModalType) => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  const { register, setValue, control, handleSubmit } =
    useFormContext<ApplyLeaveFormDataType>();

  const { data: commonInfoResponse } = useEmployeeServiceData({
    dataType: EMPLOYEE_SERVICE_DATA.LEAVE_APPLY_COMMON_INFO,
    gradeId: gradeId,
  });

  const commonInfo = commonInfoResponse?.commonInfo || [];

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={onClose}
      closeAble
      portal
    >
      <Header
        size="sm"
        headerText={{
          header: "Assign File Inquiry",
          subHeader: "Select employee to assign file inquiry",
        }}
        avatar={<Avatar size="sm" />}
        className="px-9"
      />
      <form onSubmit={handleSubmit(handleSendForApproval)}>
        <div className="p-10 d-flex flex-column gap-8">
          <SelectControllerVertical
            label="FILE_INQUIRY.FORM.SEND_TO"
            control={control}
            name={"assigneeId"}
            register={{
              ...register("assigneeId", {
                required: "Select file on hand employee",
              }),
            }}
            options={getEmployeeServiceDataConvert(commonInfo, language)}
            setValue={setValue}
            isSearchable
            required
          />
          <InputDateControllerVertical
            control={control}
            label="FILE_INQUIRY.FORM.FILE_FROM_DATE"
            name="fileFromDate"
            register={{
              ...register("fileFromDate", {
                required: "File from date is required",
              }),
            }}
            required
          />

          <div className="d-flex justify-content-end">
            <Button
              fill="fill"
              size="sm"
              type="primary"
              htmlType="submit"
              loading={isLoading}
            >
              {t("FILE_INQUIRY.ASSIGN_BUTTON")}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};
